// eslint-disable-next-line max-len
export const findCategory = state => categoryId => state.all.find(category => category.id === categoryId);
